import {generateFormValidations} from "../../../../helpers/antdFormValidations";
import {CreateFleetExpensesTransportFormValues} from "./CreateFleetExpensesTransportModal";

const generateCreateTransportValidations = generateFormValidations<CreateFleetExpensesTransportFormValues>({
  tc_number: [
    { required: true, message: 'TC number is required' },
  ],
});

export default generateCreateTransportValidations;